module.exports = __webpack_public_path__ + "static/media/payment-logo.e90b49dd.png";